import React, { PropTypes, Component } from 'react';
import { VideoPlayer } from 'components/Widgets';
import Embed from 'components/Page/Module/Embed';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    margin: 'auto',
    width: '100%'
  },
  container: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0
  },
  normalContainer: {
    position: 'relative'
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none'
  }
});

export default class EmbeddedVideoPreview extends Component {
  static contextTypes = {
    media: PropTypes.string
  };

  renderIFrame() {
    return (
      <div
        className={classNames(css.root, this.props.className)}
        style={this.props.style}
      >
        <div className={css.container}>
          <iframe
            className={css.iframe}
            src={this.props.source}
            allowTransparency={true}
            frameBorder={0}
            scrolling={'no'}
            webkitAllowFullScreen
            mozAllowFullScreen
            allowFullSreen
            oAllowFullScreen
            msAllowFullScreen
          />
        </div>
      </div>
    );
  }

  getExtension(url) {
    url = url || '';
    return url.substr((~-url.lastIndexOf('.') >>> 0) + 2);
  }

  renderVideoPlayer() {
    return (
      <VideoPlayer
        sources={[
          { url: this.props.src, type: this.getExtension(this.props.src) }
        ]}
      />
    );
  }

  renderEmptyVideo() {
    return <VideoPlayer sources={[]} />;
  }

  renderEmbed() {
    return (
      <Embed provider={this.props.source.provider} id={this.props.source.src} />
    );
  }

  render() {
    if (typeof this.props.source === 'string') {
      return this.renderIFrame();
    } else if (this.props.source && this.props.source.provider) {
      return this.renderEmbed();
    } else if (this.props.source && this.props.source.src) {
      return this.renderVideoPlayer();
    } else {
      return this.renderEmptyVideo();
    }
    // 3 standards
  }
}



// WEBPACK FOOTER //
// ./src/js/components/EmbeddedVideoPreview.js